
  export default {
    components: {
      PageContent: () => import("~/components/product_info/PageContent"),
    },
    data: () => ({
      loaded: false,
      product: [],
      related_products: [],
      steps: [
        {
          name: "Choose a Product",
          description: "Choose the right insurance best for you.",
          order: 1,
          image: "/assets/products/Choose.webp",
        },
        {
          name: "Apply Online",
          description: "Be insured through our online insurance platform. ",
          order: 2,
          image: "/assets/products/Apply.webp",
        },
        {
          name: "Verification",
          description:
            "The insurance policy will be delivered to your registered email address.",
          order: 3,
          image: "/assets/products/Verification.webp",
        },
      ],
    }),
    mounted ()
    {
      this.toggleModalStatus({type: "loader", status: true});
      this.$axios
        .$get(`web/products/${ this.$route.params.product }`)
        .then((response) =>
        {
          this.product = response.res.product;
          this.related_products = response.res.related_products;
        })
        .catch((err) =>
        {
          error({statusCode: 500, message: "Something Went Wrong"});
        })
        .then(() =>
        {
          setTimeout(() =>
          {
            this.loaded = true;
            this.toggleModalStatus({type: "loader", status: false});
          }, 150);
        });
    },
    head ()
    {
      let host = process.env.BASE_URL,
        meta_title = "Products | Malayan Insurance",
        meta_description =
          "Malayan Insurance is one of the leading non-life insurance company in the Philippines that insures your travels, motors, homes, personal accident and more. ",
        meta_keywords = "malayan insurance products";
      switch (this.$route.params.product)
      {
        case "vital-cover":
          (meta_title =
            "Vital Cover for Personal and Family Insurance | Malayan Insurance"),
            (meta_description =
              "Malayan Insurance provides vital cover to protect you, your family and your loved ones. Click here to learn more about our personal and family insurance plans.");
          meta_keywords =
            "malayan insurance family shield, malayan insurance products";
          break;
        case "travel-master":
          (meta_title =
            "Travel Master Lifestyle Insurance | Malayan Insurance Philippines"),
            (meta_description =
              "Malayan Lifestyle Insurance's Travel Master offers protection against Covid, Emergency and other unforeseen incidents. Get a free quote today!");
          meta_keywords = "malayan travel insurance, malayan insurance products";
          break;
        case "travel-lite":
          (meta_title = "Malayan Insurance Philippines | Travel Lite"),
            (meta_description =
              "Our Travel Lite Insurance offers the most affordable Travel Insurance that covers covid, emergency, and other risks. Get a free quote today.");
          meta_keywords = "malayan travel insurance, malayan insurance products";
          break;
        case "pet-insurance":
          (meta_title =
            "Pet Care Lifestyle Insurance | Malayan Insurance Philippines"),
            (meta_description =
              "Get your pet insured with Malayan Insurance. Protect them from any unexpected accidents or illnesses. Check out our Pet Care to Learn more and Get a Free Quote.");
          meta_keywords = "malayan pet insurance, malayan insurance products";
          break;
        case "home-protect":
          (meta_title =
            "Home Protect Home Insurance | Malayan Insurance Philippines"),
            (meta_description =
              "Malayan Insurance Philippines Home Protect is the unbeatable home insurance you can get today! Get your free quote and enjoy the benefits of home protect today!");
          meta_keywords =
            "malayan property insurance, malayan insurance products";
          break;
        case "home-protect-lite":
          (meta_title =
            "Home Protect Lite Home Insurance | Malayan Insurance Philippines"),
            (meta_description =
              "Get a free quotation for the most affordable home insurance in the market. Get your free quote today and enjoy many benefits with Home Protect Lite today!");
          meta_keywords =
            "malayan property insurance, malayan insurance products";
          break;
        case "automaster":
          (meta_title =
            "AutoMaster Car Insurance | Malayan Insurance Philippines"),
            (meta_description =
              "Get a car insurance quote today from Malayan Insurance Philippines. Protect your car and get peace of mind with Auto Master Car Insurance.");
          meta_keywords =
            "malayan car insurance, malayan comprehensive car insurance";
          break;
        case "motoone":
          (meta_title =
            "MotoOne Motorcycle Insurance | Malayan Insurance Philippines"),
            (meta_description =
              "Get a motorcycle insurance quote today from Malayan Insurance Philippines. Protect your motorcycle and get peace of mind with MotoOne Insurance.");
          meta_keywords =
            "malayan motorcycle insurance, malayan comprehensive motorcycle insurance";
          break;
      }
      return {
        title: meta_title,
        link: [
          {
            href: `https://malayan.com${ this.$route.fullPath }`,
          },
        ],
        meta: [
          {name: "keywords", content: meta_keywords},
          {hid: "og:title", property: "og:title", content: meta_title},
          {
            hid: "og:description",
            property: "og:description",
            content: meta_description,
          },
          {
            name: "description",
            hid: "description",
            property: "description",
            content: meta_description,
          },          
          {
            hid: "og:url",
            property: "og:url",
            content: `https://malayan.com${ this.$route.fullPath }`,
          },
          {hid: "og:image", property: "og:image", content: "/cbimage.webp"},
          {hid: "og:image:alt", property: "og:image:alt", content: "Malayan Insurance"},
          {hid: "og:site_name", property: "og:site_name", content: "Malayan Insurance"},
          {hid: "og:type", property: "og:type", content: "website"},
        ],
      };
    },
  };
